import { UncubesQuery } from '@dynameat/views/reporting/models/uncubesQuery';

export class ProductSalesQuery extends UncubesQuery {
  projection = 'ticket_sales'

  cuts = [{
    expression: 'NOT (product_name LIKE \'%***%\')'
  }]

  rows = [{
    kpi: 'product_name'
  }]

  orderBy = [
    { kpi: 'SUM_ticket_line_quantity', order: 'desc', function: 'SUM' }
  ]

  aggregates = [
    { kpi: 'ticket_line_quantity', function: 'SUM' },
    { kpi: 'ticket_line_amount', function: 'SUM' },
    { kpi: 'ticket_line_cost', function: 'SUM' }]

  limit = 100

  constructor(pointOfSaleGuid, dateStart, dateEnd, isManaged = false, extraResults = 0) {
    super();
    this.limit += extraResults;
    this.cuts.push(...[
      { expression: `point_of_sale_guid = '${pointOfSaleGuid}'` },
      { expression: `ticket_line_date between '${dateStart}' and '${dateEnd}'` },
      { expression: "product_is_menu_enabled = 'True'" }]);
    if (isManaged) {
      this.cuts.push({ expression: "product_is_revenue_managed = 'True'" });
    }
  }
}
